import ManageDeployments from './ManageDeployments.container';

export default ManageDeployments;
